export default __webpack_public_path__ + "static/media/Route_filled.a8e230ef.svg";